import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

/** Key used to choose session storage: "remember me" = localStorage, else = sessionStorage (session only) */
export const REMEMBER_ME_KEY = 'hp-remember-me';

function getAuthStorage() {
  const useSessionOnly = typeof localStorage !== 'undefined' && localStorage.getItem(REMEMBER_ME_KEY) === 'false';
  return useSessionOnly ? sessionStorage : localStorage;
}

/** Custom storage so "Remember me" unchecked = sessionStorage (logout on tab close), checked = localStorage */
const authStorage = {
  getItem: (key) => getAuthStorage().getItem(key),
  setItem: (key, value) => getAuthStorage().setItem(key, value),
  removeItem: (key) => getAuthStorage().removeItem(key),
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: authStorage,
  },
});
